// removed by extract-text-webpack-plugin
module.exports = {"Nav":"SearchMenu__Nav-4r2et","Toggle":"SearchMenu__Toggle-77skP","ToggleIcon":"SearchMenu__ToggleIcon-2pWuH","Toggle--here":"SearchMenu__Toggle--here-Lm1T7","Menu":"SearchMenu__Menu-LM07o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchMenu/SearchMenu.css
 ** module id = 641
 ** module chunks = 0
 **/